import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { loadMainAction, resetMain } from "redux/reducers/home";
import { Cookies } from "react-cookie";
import BannerAndInfo from "components/home/banner-and-info";
import Stamp from "components/home/stamp";
// import Club from "components/home/club";
import Product from "components/home/product";
import Recommend from "components/home/recommend";
import HoneyBenefit from "components/home/honey-benefit";
import AdvanceReservation from "components/home/advance-reservation";
import Footer from "components/home/footer";
import AlertConfirm from "components/ui/alert-confirm";
import {
  loadAction,
  loadAlert,
  loadFavAlert,
  loadAppCard,
  loadSidebar,
  loadLinkAlert,
} from "redux/reducers/top";
import Popup from "components/ui/popup";
import { setBottomColor, splashHide } from "assets/js/apphandle";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { goLink, setCookiesSync } from "assets/js/common";
import { exitApp, getAuth } from "assets/js/apphandle";
import DrawerTutorial from "components/tutorial";
import { refreshFavInfo } from "assets/js/favInfo";
import UpdatePopup from "components/ui/update-popup";

let cookies = new Cookies();

function isOutdated(deviceVer, minVer) {
  const p1 = String(deviceVer || "0").split(".").map(Number);
  const p2 = String(minVer || "0").split(".").map(Number);
  for (let i = 0; i < Math.max(p1.length, p2.length); i++) {
    if ((p1[i] || 0) < (p2[i] || 0)) return true;
    if ((p1[i] || 0) > (p2[i] || 0)) return false;
  }
  return false;
}

function Home() {
  // const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const token = cookies.get("X-AUTH-TOKEN");
  let favInfo = cookies.get("favInfo");

  const { data, loading } = useSelector((state) => state.home);

  const [showPopup, setShowPopup] = useState(false);

  const [redirectPath, setRedirectPath] = useState("");
  const [tp, setTp] = useState(
    favInfo && favInfo.visibleTp ? favInfo.visibleTp : "1"
  );
  const [storeCode, setStoreCode] = useState(
    favInfo ? (favInfo.visibleTp === "1" ? favInfo.favMt : favInfo.favMk) : ""
  );
  const [fullOpen, setFullOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [updatePopup, setUpdatePopup] = useState(false);

  const handlePopupClose = () => {
    setOpen(false);
  };
  const handlePopupOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    let localFavInfo = cookies.get("favInfo");
    setTp(
      localFavInfo && localFavInfo.visibleTp ? localFavInfo.visibleTp : "1"
    );
    setStoreCode(
      localFavInfo
        ? localFavInfo.visibleTp === "1"
          ? localFavInfo.favMt
          : localFavInfo.favMk
        : ""
    );
  }, [cookies.get("favInfo")]);

  const { accessiblePages, loginSuccess } = useSelector((state) => state.user);
  const { alertOpen, favAlertOpen, appCardOpen, sidebarOpen, linkAlert } =
    useSelector((state) => state.top);
  const handleAlertOpen = (path) => {
    setRedirectPath(path);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const goLogin = () => {
    handleAlertClose();
    history.push(redirectPath);
  };

  const goPage = (path) => {
    if (token) {
      history.push(path);
    } else {
      dispatch(loadAlert(true));
    }
  };

  const handleFullOpen = () => {
    setFullOpen(true);
  };

  const handleDialogFullClose = () => {
    window.location.href = "/";
    // setFullOpen(false);
  };

  const fetchData = () => {
    let localFavInfo = cookies.get("favInfo");

    return new Promise((resolve) => {
      dispatch(
        loadMainAction({
          schTp: localFavInfo ? localFavInfo.visibleTp : "1",
          schStore: storeCode,
        })
      );
      resolve(true);
    });
  };

  useEffect(() => {
    let checked = cookies.get("checked") || "";
    let autoToken = cookies.get("autoToken") || "";

    if (location.search === "?isFirst=Y") {
      // if (checked == "true" && autoToken) {
      //   let fav = cookies.get("favInfo");

      //   let cookieExpires = new Date();
      //   cookieExpires.setDate(cookieExpires.getDate() + 90);
      //   setCookiesSync("favInfo", {
      //     defaultTp: fav.defaultTp, //설정에서 세팅하는 tp
      //     visibleTp: fav.defaultTp, //메인 화면에서 변경시키는 tp
      //     favMk: fav.favMk,
      //     favMt: fav.favMt,
      //   });
      // cookies.set(
      //   "favInfo",
      //   {
      //     defaultTp: fav.defaultTp, //설정에서 세팅하는 tp
      //     visibleTp: fav.defaultTp, //메인 화면에서 변경시키는 tp
      //     favMk: fav.favMk,
      //     favMt: fav.favMt,
      //   },
      //   {
      //     path: "/",
      //     expires: cookieExpires,
      //   }
      // );
      // } else {
      //   cookies.remove("favInfo", { path: "/" });
      // }
      dispatch(resetMain());
    } else fetchData();
    splashHide();

    window.appAuthHandle = (json) => {
      let data = JSON.parse(json);

      const continueAuth = () => {
        if (data.isFirst) {
          //튜토리얼
          setFullOpen(true);
        }
        if (data.pushUrl) {
          checkLink(data.pushUrl);
        } else {
          setShowPopup(true);
        }
        fetchData();
        window.history.replaceState({}, null, window.location.pathname);
      };

      let os = "";
      if (window.Android) {
        os = "android";
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ios
      ) {
        os = "ios";
      }

      if (os) {
        axios
          .post("api/app/ver.do", {}, { headers: { OS: os } })
          .then((res) => {
            const verData = res.data.data;
            if (isOutdated(data.ver, verData.ver)) {
              setUpdatePopup(true);
              return;
            }
            continueAuth();
          })
          .catch(() => {
            continueAuth();
          });
      } else {
        continueAuth();
      }
    };

    if (location.search == "?isFirst=Y") {
      getAuth();
    }
    return () => {
      if (showPopup) {
        setShowPopup(false);
      }
    };
  }, []);

  useState(() => {
    if (loginSuccess) {
      fetchData();
    }
  }, [loginSuccess]);

  const logout = (returnFunc) => {
    if (window.Android) {
      window.Android.logout(returnFunc);
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "logout",
        func: returnFunc,
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    }
  };

  const { init } = useSelector((state) => state.top);

  useEffect(() => {
    dispatch(loadAction({ back: false, menu: true, title: "", main: true }));
  }, [init]);

  const checkLink = (link) => {
    if (link.indexOf("/") == 0) {
      let find = accessiblePages.find((page) => link.indexOf(page) > -1);
      if (find) {
        history.push(link);
      } else {
        if (token) {
          history.push(link);
        } else {
          dispatch(loadAlert(true));
        }
      }
    } else {
      goLink(link);
    }
  };

  const [drawerHigh, setDrawerHigh] = useState(false);
  // 종이전단 팝업
  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  useEffect(() => {
    if (drawerHigh === true) setBottomColor("FFFFFF");
    else setBottomColor("F1270B");
  }, [drawerHigh]);

  // useEffect(() => {
  //   window.appBackKeyHandle = () => {
  //     if (alertOpen) {
  //       dispatch(loadAlert(false));
  //     } else if (favAlertOpen) {
  //       dispatch(loadFavAlert(false));
  //     } else if (appCardOpen) {
  //       dispatch(loadAppCard(false));
  //     } else if (fullOpen) {
  //       handleDialogFullClose();
  //     } else if (open) {
  //       handlePopupClose();
  //     } else if (drawerHigh) {
  //       handleDrawerHighClose();
  //     } else if (
  //       !alertOpen ||
  //       !appCardOpen ||
  //       !favAlertOpen ||
  //       !fullOpen ||
  //       !open ||
  //       !drawerHigh
  //     ) {
  //       exitApp();
  //     }
  //   };
  // }, [alertOpen, appCardOpen, favAlertOpen, fullOpen, open, drawerHigh]);

  window.appBackKeyHandle = () => {
    if (alertOpen) {
      dispatch(loadAlert(false));
    } else if (favAlertOpen) {
      dispatch(loadFavAlert(false));
    } else if (linkAlert) {
      dispatch(loadLinkAlert(""));
    } else if (appCardOpen) {
      dispatch(loadAppCard(false));
    } else if (fullOpen) {
      handleDialogFullClose();
    } else if (open) {
      handlePopupClose();
    } else if (drawerHigh) {
      handleDrawerHighClose();
    } else {
      exitApp();
    }
  };

  return (
    <>
      <PullToRefresh
        onRefresh={fetchData}
        pullingContent={false}
        refreshingContent={<Spinner />}
        resistance={3}
      >
        <BannerAndInfo goPage={goPage} />
        {token && <Stamp />}
        {/* {tp == "2" ? <></> : <Club goPage={goPage} />} */}
        <Product
          drawerHigh={drawerHigh}
          handleDrawerHighOpen={handleDrawerHighOpen}
          handleDrawerHighClose={handleDrawerHighClose}
        />
        {tp == "2" ? <></> : <Recommend />}
        {tp == "2" ? <></> : <HoneyBenefit />}
        <Footer
          open={open}
          handlePopupOpen={handlePopupOpen}
          handlePopupClose={handlePopupClose}
        />
        {showPopup && <Popup />}
        <DrawerTutorial
          open={fullOpen}
          handleDialogFullClose={handleDialogFullClose}
        />
      </PullToRefresh>
      <UpdatePopup open={updatePopup} />
    </>
  );
}

export default Home;
